import { FieldKey } from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import { VoucherCode } from '@products/models/voucher.model';

export const enum LoginOptions {
  None = 'none',
  HideTopBarLogin = 'hideTopBarLogin',
  OptionalPersonalLogin = 'optionalPersonalLogin',
  OptionalTicketLogin = 'optionalTicketLogin',
  OptionalTicketAndPersonalLogin = 'optionalTicketAndPersonalLogin',
  PersonalizationWithRequiredEmailConfirmation = 'personalizationWithRequiredEmailConfirmation',
  BeforeTicketSelection = 'beforeTicketSelection',
  BeforeTicketSelectionWithRequiredEmailConfirmation = 'beforeTicketSelectionWithRequiredEmailConfirmation',
  AddTicketsAfterLogin = 'addTicketsAfterLogin'
}

export const CheckUserAccountTicketLimitLoginOptions = [
  LoginOptions.None,
  LoginOptions.OptionalPersonalLogin,
  LoginOptions.OptionalTicketLogin,
  LoginOptions.OptionalTicketAndPersonalLogin,
  LoginOptions.BeforeTicketSelection,
  LoginOptions.BeforeTicketSelectionWithRequiredEmailConfirmation,
  LoginOptions.PersonalizationWithRequiredEmailConfirmation,
  LoginOptions.AddTicketsAfterLogin
];

export interface AccountVerificationStatus {
  isVerifiedAccountRequired: boolean;
  isAccountVerified: boolean;
}

export const enum SocialLoginQueryParamsLoginType {
  Unknown = 'Unknown',
  Anonymous = 'Anonymous',
  Registration = 'Registration',
  Import = 'Import',
  LegitimationImport = 'LegitimationImport',
  VoucherImport = 'VoucherImport',
  Facebook = 'Facebook',
  Google = 'Google',
  LinkedIn = 'LinkedIn',
  X = 'X',
  Vkontakte = 'Vkontakte',
  ConteoLogin = 'ConteoLogin',
  Microsoft = 'Microsoft',
  Apple = 'Apple',
  Amazon = 'Amazon',
  SocialLoginError = 'SocialLoginError'
}

export const enum SocialLoginQueryParamsFirstLogin {
  True = 'True',
  False = 'False'
}

export interface SocialLoginQueryParams {
  voucher: VoucherCode;
  userId: string;
  authToken: string;
  firstLogin: SocialLoginQueryParamsFirstLogin;
  type: SocialLoginQueryParamsLoginType;
  error: string;
}

export interface LoginFormFields {
  [FieldKey.Email]: string;
  [FieldKey.Password]: string;
}
